import styles from './Icons.module.css';
import { ReactComponent as Facebook } from 'assets/social-links/facebook.svg';

export const FacebookIcon = () => (
    <div className={styles['icon']}>
        <Facebook />
    </div>
);
